import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useCallback, useEffect, useRef } from 'react';
const CONTAINER_CSS = css `
  white-space: nowrap;
`;
const BLINKER_CSS = css `
  display: inline-block;
  width: 10px;
  height: 10px;
  min-width: 10px;
  min-height: 10px;
  background-color: green;
  margin-left: 3px;
`;
export const FpsCounter = () => {
    const frameCountRef = useRef(0);
    const isBlinkerOnRef = useRef(true);
    const blinkerRef = useRef(null);
    const spanRef = useRef(null);
    const tickIdRef = useRef();
    const tick = useCallback(() => {
        frameCountRef.current++;
        tickIdRef.current = requestAnimationFrame(tick);
    }, []);
    useEffect(() => {
        tickIdRef.current = requestAnimationFrame(tick);
        return () => {
            if (tickIdRef.current !== undefined) {
                cancelAnimationFrame(tickIdRef.current);
            }
        };
    }, [tick]);
    useEffect(() => {
        const renderIntervalId = setInterval(() => {
            const currFrameCount = frameCountRef.current;
            frameCountRef.current = 0;
            if (!spanRef.current) {
                return;
            }
            spanRef.current.innerText = `${currFrameCount}`;
            isBlinkerOnRef.current = !isBlinkerOnRef.current;
            if (blinkerRef.current) {
                blinkerRef.current.style.visibility = isBlinkerOnRef.current ? 'visible' : 'hidden';
            }
        }, 1000);
        return () => {
            clearInterval(renderIntervalId);
        };
    }, []);
    return (_jsxs("span", { css: CONTAINER_CSS, children: [_jsx("span", { ref: spanRef, children: "0" }), " FPS", _jsx("span", { ref: blinkerRef, css: BLINKER_CSS })] }));
};
